import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchgame, searchplatform, searchchannel, searchpkg } from "@/api/dataAll/dataAll";
import { payTypeList, delconfig } from "@/api/aymentsdk/aymentsdk";
import { getadvLocation } from "@/api/dataAll/advLocation";
import addTypeConfig from "./components/addTypeConfig";
export default {
  name: "typeConfiguration",
  components: {
    addTypeConfig: addTypeConfig
  },
  data: function data() {
    return {
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      // advchannels:[],
      advLocation: [],
      gameId: "",
      value1: "",
      value2: [],
      searchData: {
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        starttime: "",
        endtime: "",
        // advChannel:'',
        advLocation: ""
      },
      showing: false,
      searchMark: {},
      tableData: [],
      addTypeConfig: false,
      total: 0,
      page: 1
    };
  },
  created: function created() {
    var _this = this;

    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
  },
  methods: {
    gamechange: function gamechange(id) {
      var _this2 = this;

      if (id != "") {
        searchplatform({
          game_id: id
        }).then(function (res) {
          _this2.searchplatforms = res.data;
          _this2.searchData.platform = "";
          _this2.searchData.channel = "";
          _this2.searchData.pkg = "";
          _this2.searchMark.platform = "";
          _this2.searchMark.channel = "";
          _this2.searchMark.pkg = ""; // this.searchData.advChannel = '';

          _this2.searchData.advLocation = ""; // this.searchMark.ad_channel='';

          _this2.searchchannels = []; // this.advchannels = [];

          _this2.advLocation = [];
          _this2.searchpkgs = [];

          _this2.searchgames.forEach(function (item) {
            if (item.id == id) {
              _this2.searchMark.game = item.game_mark;
            }
          });
        });
      } else {
        this.searchData.platform = "";
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchMark.channel = "";
        this.searchplatforms = [];
        this.searchchannels = [];
        this.searchpkgs = [];
        this.searchMark.game = ""; // this.searchData.advChannel = '';

        this.searchData.advLocation = ""; // this.searchMark.ad_channel='';
        // this.advchannels = [];

        this.advLocation = [];
      }
    },
    platformchange: function platformchange(id) {
      var _this3 = this;

      if (id != "") {
        searchchannel({
          platform_id: id
        }).then(function (res) {
          _this3.searchchannels = res.data.channel; // this.advchannels=res.data.adv_platform;

          _this3.searchData.channel = "";
          _this3.searchData.pkg = ""; // this.searchData.advChannel='';

          _this3.searchData.advLocation = "";
          _this3.searchMark.channel = "";
          _this3.searchMark.pkg = ""; // this.searchMark.ad_channel='';

          _this3.advLocation = [];
          _this3.searchpkgs = [];

          _this3.searchplatforms.forEach(function (item) {
            if (item.id == id) {
              _this3.searchMark.platform = item.platform_mark;
              _this3.searchData.channel = "";
              _this3.searchMark.channel = "";
            }
          });
        });
      } else {
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.channel = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchpkgs = [];
        this.searchchannels = []; // this.searchData.advChannel = '';

        this.searchData.advLocation = ""; // this.searchMark.ad_channel='';
        // this.advchannels = [];

        this.advLocation = [];
      }
    },
    channelchange: function channelchange(id) {
      var _this4 = this;

      if (id != "") {
        searchpkg({
          channel_id: id
        }).then(function (res) {
          _this4.searchpkgs = res.data;

          _this4.searchchannels.forEach(function (item) {
            if (item.id == id) {
              _this4.searchMark.channel = item.channel_mark;
              _this4.searchData.pkg = "";
              _this4.searchMark.pkg = "";
            }
          });
        });
      } else {
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.channel = "";
        this.searchData.channel = "";
        this.searchpkgs = [];
      }
    },
    pkgchange: function pkgchange(id) {
      var _this5 = this;

      if (id != "") {
        this.searchpkgs.forEach(function (item) {
          if (item.id == id) {
            _this5.searchMark.pkg = item.pkg_mark;
          }
        });
      } else {
        this.searchMark.pkg = "";
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchClick();
    },
    searchClick: function searchClick() {
      var _this6 = this;

      if (Array.isArray(this.value2) && this.value2.length > 0) {
        this.searchMark.starttime = this.value2[0];
        this.searchMark.endtime = this.value2[1];
      }

      payTypeList(this.searchMark).then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg'];
          _this6.tableData = res.data.data.length ? _this6.$utils.dataConversion(res.data.data, list) : [];
          _this6.total = res.data.total || 0;
        }
      });
    },
    handleSource: function handleSource(id) {
      this.$refs.addTypeConfig.init(id);
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDelete: function handleDelete(id) {
      var _this7 = this;

      this.$confirm("此操作将删除该支付类型配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delconfig({
                  id: id
                }).then(function (res) {
                  _this7.searchClick();
                });

                _this7.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};